import Nullstack from 'nullstack';
export default function IconArrowsRightLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-right-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "7",
    x2: "3",
    y2: "7"
  }), "   ", Nullstack.element("path", {
    d: "M18 10l3 -3l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M6 20l-3 -3l3 -3"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "17",
    x2: "21",
    y2: "17"
  }), " ");
}